module.exports = __webpack_public_path__ + "img/cl-cedia.0ffab333.png";